import { clearInLifeOrderAndRedirectToMyAccount } from '@in-life/utils/clearInLifeOrder';
import {
  BodyText,
  Button,
  Flex,
  Heading,
} from '@utilitywarehouse/hearth-react';
import SpotUnavailableLight from '@utilitywarehouse/hearth-svg-assets/lib/spot-unavailable-light.svg';
import { useEffect } from 'react';

import { Dialog, DialogID, useDialog } from '@components/Dialog';
import { useEnergyContext } from '@features/Energy/Provider';
import { BundleBasketFragment } from '@generated/gql/graphql';

const checkIfUnavailable = (basketRaw: BundleBasketFragment) => {
  return !basketRaw.energy;
};

const InLifeEnergyTariffsUnavailableDialog = () => {
  const { setOpen } = useDialog(DialogID.IN_LIFE_ENERGY_TARIFFS_UNAVAILABLE);
  const { basketRaw, isBasketLoading } = useEnergyContext();
  const isUnavailable =
    !!basketRaw && !isBasketLoading && checkIfUnavailable(basketRaw);

  useEffect(() => {
    if (isUnavailable) {
      setOpen(true);
    }
  }, [isUnavailable, setOpen]);

  const handleBackToMyAccount = () => {
    clearInLifeOrderAndRedirectToMyAccount();
  };

  return (
    <Dialog
      id={DialogID.IN_LIFE_ENERGY_TARIFFS_UNAVAILABLE}
      hideCloseButton
      preventDismiss
    >
      <Flex
        direction="column"
        alignItems="center"
        justifyContent="center"
        gap="200"
        padding="200"
      >
        <img
          src={SpotUnavailableLight}
          alt="Spot Unavailable"
          width={130}
          height={170}
          style={{ margin: '0 auto' }}
        />
        <Heading as="h1" marginTop="200" textAlign="center">
          Sorry, our energy tariffs aren't loading right now
        </Heading>
        <BodyText textAlign="center">
          To continue, please head back to home.
        </BodyText>
        <Flex
          direction="row"
          gap="100"
          width={{ mobile: '100%', tablet: 'fit-content' }}
          marginTop="300"
        >
          <Button
            variant="solid"
            style={{ width: '100%' }}
            onClick={handleBackToMyAccount}
          >
            Back to home
          </Button>
        </Flex>
      </Flex>
    </Dialog>
  );
};

export { InLifeEnergyTariffsUnavailableDialog };
